module.exports = "../../app/cells/pages/contest/summary_cell.rb";